import React, { useMemo } from "react";

import { useIntl } from "react-intl";
import { useLocation } from "react-router-dom";

import { Link } from "ds/Button";
import { getSubscriptionEditUrl, splitStringByChar } from "Libs/utils";
import {
  selectFeatureUsageBasedBillingEnabled,
  selectExternalUrlEnabled
} from "Reducers/featureFlags/featureFlags.selectors";
import { useAppSelector } from "Store/hooks";

import type { Subscription } from "@packages/client";

type EditPlanButtonProps = {
  subscription?: Subscription;
};

const EditPlanButton = ({ subscription }: EditPlanButtonProps) => {
  const intl = useIntl();
  const location = useLocation();
  const externalUrlEnabled = useAppSelector(selectExternalUrlEnabled);

  const subscriptionEditUrl = useMemo(
    () => getSubscriptionEditUrl({ subscription }),
    [subscription]
  );
  const usageBasedBillingEnabled = useAppSelector(
    selectFeatureUsageBasedBillingEnabled
  );

  const shouldHideButton = usageBasedBillingEnabled || !subscription;

  if (shouldHideButton || !subscriptionEditUrl?.url) {
    return null;
  }

  const { pathname } = splitStringByChar(subscriptionEditUrl?.url, "#");

  const internalProps = {
    to: pathname,
    state: {
      from: "project_settings",
      url: location.pathname
    }
  };
  const externalProps = {
    href: subscriptionEditUrl?.url
  };
  const linkProps = externalUrlEnabled ? externalProps : internalProps;

  return (
    <Link {...linkProps} variant="primary" analyticId="edit_plan">
      {intl.formatMessage({ id: "edit_plan" })}
    </Link>
  );
};

export default EditPlanButton;
